import cloneDateObject from './cloneDateObject.jsx'

const getDateIntervall = (startDate, endDate) => {
    const dayIntervall = {}
    const startDateClone = cloneDateObject(startDate)

    for(let currentDate = startDateClone; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
        dayIntervall[currentDate.toISOString()] = []
    }
    return dayIntervall
}

export default getDateIntervall